import { render } from "./Admin.vue?vue&type=template&id=7858668e&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=7858668e&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7858668e"]])

export default __exports__